var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"custom-class":'supplementary-order-dialog',"visible":_vm.formVisible,"append-to-body":true},on:{"update:visible":function($event){_vm.formVisible=$event}}},[_c('FormComponent',{ref:"form",attrs:{"formData":_vm.formData,"column":_vm.column,"rules":_vm.rules,"hideBack":true},on:{"onSubmit":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }